/**
 * Fade-in for the header top bar once the Trustpilot iframe has loaded:
 * Trustpilot and the USP list fade in together, 300ms after the iframe appears.
 */
const FADE_DELAY_MS = 300;
const FALLBACK_MS = 4000;

function onWidgetReady(widget, callback) {
  if (!widget || widget.querySelector('iframe')) {
    callback();
    return;
  }

  const observer = new MutationObserver(() => {
    if (widget.querySelector('iframe')) {
      observer.disconnect();
      callback();
    }
  });
  observer.observe(widget, { childList: true, subtree: true });
}

export function initTrustpilotFade() {
  const uspList = document.querySelector('#root #nav-top > ul.l4us');
  const navItem = document.querySelector('#root #nav-top li.be-trustpilot-widget');
  const revealAll = () => {
    if (navItem) navItem.classList.add('is-loaded');
    if (uspList) uspList.classList.add('is-loaded');
  };

  window.setTimeout(revealAll, FALLBACK_MS);
  onWidgetReady(navItem && navItem.querySelector('.trustpilot-widget'), () => {
    window.setTimeout(revealAll, FADE_DELAY_MS);
  });
}
